import * as React from "react";

import { Box, Divider, Group, Stack, Text } from "@mantine/core";

import { saleTitleMap } from "~/features/manage-collection/mint-vector/MultipleMintVector";
import {
  getSaleStatus,
  getStartsInLabel,
  SaleStatus,
} from "~/features/manage-collection/types";
import { GetManageCollectionQuery } from "~/features/manage-collection/v2.queries.graphql.generated";
import { PropertyBox } from "~/features/tokens/sections/ManageToken/properties/PropertyBox";

export const MintVectorsStatus = ({
  mintVectors,
  collection,
}: {
  mintVectors: GetManageCollectionQuery["getManageCollection"]["mintVectors"];
  collection: GetManageCollectionQuery["getManageCollection"];
}) => {
  if (mintVectors.length === 1) return <></>;

  return (
    <PropertyBox
      label="Sales status"
      value={
        <Stack w="100%" spacing={0}>
          {mintVectors.map((mintVector, index) => {
            const saleStatus: SaleStatus = getSaleStatus(
              mintVector,
              collection
            );
            const saleTitle = saleTitleMap[saleStatus];
            return (
              <Box key={mintVector.id}>
                <Group>
                  <Text size="sm">{mintVector.name}</Text>
                  <Text
                    size="sm"
                    color={saleTitle.color}
                    sx={{ flexGrow: 1 }}
                    align="right"
                  >
                    {saleTitle.mintStatus.replace(
                      ":days",
                      getStartsInLabel(new Date(mintVector.start))
                    )}
                  </Text>
                </Group>
                {index < mintVectors.length - 1 && <Divider my="sm" />}
              </Box>
            );
          })}
        </Stack>
      }
    />
  );
};
